import { giphyUrl } from '@/app/util/env'
import { GET } from '@/app/util/url'
import { getCookie } from '@/util/url'
import { GifLabels } from 'types'

const LABELS_PATH = '/ajax/gif/labels'

export const fetchGifLabels = async (gifIds: string[]): Promise<GifLabels> => {
    const params = new URLSearchParams({ gif_ids: gifIds.join(',') })
    const response = await fetch(`${giphyUrl}${LABELS_PATH}?${params}`, GET())
    if (!response.ok) {
        throw new Error(`Unable to load content labels (${response.status})`)
    }
    const { result } = await response.json()
    if (!result) {
        throw new Error('Unable to load content labels')
    }
    return result as GifLabels
}

const updateGifLabels = async (gifIds: string[], labelId: number, action: 'add' | 'remove'): Promise<void> => {
    const response = await fetch(`${giphyUrl}${LABELS_PATH}`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-CSRFToken': getCookie('csrftoken'),
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: new URLSearchParams({
            gif_ids: gifIds.join(','),
            action,
            label_id: `${labelId}`,
        }).toString(),
    })
    if (!response.ok) {
        throw new Error(`Unable to update content labels (${response.status})`)
    }
}

export const addGifLabel = (gifIds: string[], labelId: number): Promise<void> => updateGifLabels(gifIds, labelId, 'add')

export const removeGifLabel = (gifIds: string[], labelId: number): Promise<void> =>
    updateGifLabels(gifIds, labelId, 'remove')
